import { render, staticRenderFns } from "./u-btn-text-fit.vue?vue&type=template&id=3fed72fe&scoped=true"
import script from "./u-btn-text-fit.vue?vue&type=script&lang=js"
export * from "./u-btn-text-fit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed72fe",
  null
  
)

export default component.exports